import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BlogService } from '../../services/blog.service';
import { Blog } from '../../models/blog';

@Component({
  selector: 'app-manage-blogs',
  templateUrl: './manage-blogs.component.html',
  styleUrls: ['./manage-blogs.component.css']
})
export class ManageBlogsComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();

  title = 'Manage Blogs';
  blogs: Blog;
  error: string;

  constructor(private blogService: BlogService) { }

  ngOnInit() {
    this.blogService.getBlogs().pipe(takeUntil(this.destroy$)).subscribe(
      (data: Blog) => this.blogs = data,
      error => this.error = error
    );
  }

  onDelete(id: number) {
    if (confirm('Are you sure want to delete id = ' + id)) {
      this.blogService.deleteBlog(+id).pipe(takeUntil(this.destroy$)).subscribe(
        res => {
          this.ngOnInit();
        },
        error => this.error = error
      );
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
